import React from "react";

const PreviewData = ({fileData, headerMapping, onBack, onContinue}) => {
    const {data} = fileData;

    const systemFields = Object.keys(headerMapping); // Use system field names

    const formatCell = (value) => {
        // Excel stores dates as serials (days since 1899-12-30, with an off-by-one bug)
        if (typeof value === "number" && value > 30000 && value < 50000) {
            const serialDays = Math.floor(value);
            const excelEpoch = new Date(Date.UTC(1899, 11, 30));

            // Excel wrongly counts 1900 as a leap year, so we subtract 1 day
            const utcTimestamp = excelEpoch.getTime() + (serialDays - 1) * 86400000;
            const correctedDate = new Date(utcTimestamp);

            // Format as YYYY-MM-DD without any timezone effects
            return correctedDate.toISOString().split("T")[0];
        }

        if (value instanceof Date && !isNaN(value)) {
            // Handle direct Date instances safely
            return value.toISOString().split("T")[0];
        }

        return value ?? "";
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-semibold mb-4">Mapped Preview</h2>

            <div className="overflow-auto border rounded shadow">
                <table className="table-auto min-w-full text-sm text-left border-collapse">
                    <thead className="bg-gray-100">
                    <tr>
                        {systemFields.map((sysField, idx) => (
                            <th key={idx} className="border px-3 py-2 font-semibold">
                                {sysField}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {data.slice(0, 10).map((row, rowIndex) => (
                        <tr key={rowIndex} className="odd:bg-white even:bg-gray-50">
                            {systemFields.map((sysField, colIndex) => (
                                <td key={colIndex} className="border px-3 py-2">
                                    {formatCell(row[headerMapping[sysField]] ?? "")}
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <p className="text-xs text-gray-500 mt-2">Showing first 10 rows</p>

            <div className="mt-6 flex justify-between">
                <button className="btn btn-secondary" onClick={onBack}>Back to Mapping</button>
                <button className="btn btn-primary" onClick={onContinue}>Continue to Process</button>
            </div>
        </div>
    );
};

export default PreviewData;